import { HeroAnimation } from "./HeroAnimation";
import type { Theme } from "./theme";

export function Hero({ theme }: { theme: Theme }) {
  return (
    <section
      style={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        isolation: "isolate",
        background: theme.bg,
      }}
    >
      <HeroAnimation theme={theme} />
      <style>{`
        @supports (-webkit-touch-callout: none) {
          .heimar-hero-tagline,
          .heimar-hero-subtagline,
          .heimar-hero-tertiary {
            color: ${theme.fg} !important;
            mix-blend-mode: normal !important;
          }
        }
      `}</style>
      <div
        style={{
          position: "relative",
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 clamp(20px, 5vw, 40px)",
          width: "100%",
        }}
      >
        <h1
          className="heimar-hero-tagline"
          style={{
            fontSize: "clamp(44px, 7vw, 112px)",
            lineHeight: 1.02,
            letterSpacing: "-2.4px",
            fontWeight: 700,
            color: "#ffffff",
            mixBlendMode: "difference",
            margin: 0,
            maxWidth: 1000,
            textWrap: "balance",
          }}
        >
          Human-centric products. AI where it helps.
        </h1>
        <p
          className="heimar-hero-subtagline"
          style={{
            fontSize: "clamp(18px, 2vw, 26px)",
            lineHeight: 1.35,
            letterSpacing: "-0.3px",
            fontWeight: 400,
            color: "#ffffff",
            mixBlendMode: "difference",
            margin: "28px 0 0",
            maxWidth: 820,
            textWrap: "balance",
          }}
        >
          Heimar builds B2B and B2C products that pair AI with human judgement to improve outcomes.
        </p>
        <p
          className="heimar-hero-tertiary"
          style={{
            fontSize: "clamp(20px, 2.2vw, 30px)",
            lineHeight: 1.3,
            letterSpacing: "-0.4px",
            fontWeight: 500,
            color: "#ffffff",
            mixBlendMode: "difference",
            margin: "20px 0 0",
            maxWidth: 820,
            textWrap: "balance",
          }}
        >
          We are the team behind Rarion.
        </p>
      </div>
    </section>
  );
}
